module.exports = __webpack_public_path__ + "static/img/yi.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stars/yi.jpg
// module id = sUBK
// module chunks = 0